//const baseUrl = 'https://f5s6qaw2yl.execute-api.sa-east-1.amazonaws.com'; //HOMOLOG
const baseUrl = 'https://vrx4xtjxh0.execute-api.sa-east-1.amazonaws.com'; //PRODUCAO
export default baseUrl;